/**
 * Cart Drawer JS — slide-out cart with AJAX updates
 */

(function() {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (!drawer) return;

  var body = drawer.querySelector('[data-cart-drawer-body]');
  var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
  var totalEl = drawer.querySelector('[data-cart-drawer-total]');
  var footer = drawer.querySelector('[data-cart-drawer-footer]');
  var emptyState = drawer.querySelector('[data-cart-drawer-empty]');

  // a11y: closed drawer must not be keyboard-focusable (transform-hidden → inert).
  if (!drawer.classList.contains('is-open')) drawer.inert = true;

  // Open/close
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.inert = false;
    overlay.classList.add('is-active');
    fetchAndRender();
    var first = drawer.querySelector('[data-cart-drawer-close], a[href], button');
    if (first) first.focus({ preventScroll: true });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    overlay.classList.remove('is-active');
    var trigger = document.querySelector('[data-cart-toggle]');
    if (trigger) trigger.focus();
  }

  // Event listeners
  document.addEventListener('cart:open', openDrawer);

  var cartToggle = document.querySelector('[data-cart-toggle]');
  if (cartToggle) {
    // capture:true — preventDefault musí byť v capture fáze, inak Safari na /cart
    // stránke spustí same-URL scroll PRED bubble fázou
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    }, true);
  }

  document.querySelectorAll('[data-cart-drawer-close]').forEach(function(el) {
    el.addEventListener('click', closeDrawer);
  });

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Fetch cart and render
  function fetchAndRender() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { render(cart); })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  function render(cart) {
    // Update header count
    var countEl = document.querySelector('[data-cart-count]');
    if (countEl) countEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      if (body) body.style.display = 'none';
      if (footer) footer.style.display = 'none';
      if (emptyState) emptyState.style.display = 'flex';
      return;
    }

    if (body) body.style.display = '';
    if (footer) footer.style.display = '';
    if (emptyState) emptyState.style.display = 'none';

    // Total
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Items
    if (itemsContainer) {
      var html = '';
      cart.items.forEach(function(item) {
        var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_80x80$1$2') : '';
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';

        html += '<div class="cart-drawer__item" data-line-key="' + item.key + '">';
        html += '<div class="cart-drawer__item-image">';
        if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">';
        html += '</div>';
        html += '<div class="cart-drawer__item-info">';
        html += '<div class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</div>';
        if (variantTitle) html += '<div class="cart-drawer__item-variant">' + escapeHtml(variantTitle) + '</div>';
        html += '<div class="cart-drawer__item-bottom">';
        html += '<div class="cart-drawer__item-qty">';
        html += '<button data-drawer-qty-minus="' + item.key + '">−</button>';
        html += '<input type="text" inputmode="numeric" pattern="[0-9]*" value="' + item.quantity + '" data-drawer-qty-input="' + item.key + '" aria-label="' + jcDrawerI18n('qtyLabel', 'Množství') + '">';
        html += '<button data-drawer-qty-plus="' + item.key + '">+</button>';
        html += '</div>';
        html += '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>';
        html += '</div>';
        html += '<button class="cart-drawer__item-remove" data-drawer-remove="' + item.key + '">' + jcDrawerI18n('removeBtn', 'Odebrat') + '</button>';
        html += '</div>';
        html += '</div>';
      });
      itemsContainer.innerHTML = html;

      // Attach qty events
      itemsContainer.querySelectorAll('[data-drawer-qty-minus]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          updateItemQuantity(this.getAttribute('data-drawer-qty-minus'), -1);
        });
      });
      itemsContainer.querySelectorAll('[data-drawer-qty-plus]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          updateItemQuantity(this.getAttribute('data-drawer-qty-plus'), 1);
        });
      });
      // Přímá editace množství (přepsání čísla) — change se spustí na blur i Enter
      itemsContainer.querySelectorAll('[data-drawer-qty-input]').forEach(function(input) {
        input.addEventListener('focus', function() { this.select(); });
        input.addEventListener('change', function() {
          setItemQuantity(this.getAttribute('data-drawer-qty-input'), this.value);
        });
      });
      itemsContainer.querySelectorAll('[data-drawer-remove]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          removeItem(this.getAttribute('data-drawer-remove'));
        });
      });
    }
  }

  function updateItemQuantity(key, delta) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var item = cart.items.find(function(i) { return i.key === key; });
        if (!item) return;
        var newQty = Math.max(0, item.quantity + delta);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) { render(cart); });
  }

  // Nastaví množství na ABSOLUTNÍ hodnotu (přepsání čísla v poli).
  // Prázdný/neplatný vstup → obnoví skutečný stav (neodebere omylem). 0 = odebrat.
  function setItemQuantity(key, raw) {
    var trimmed = String(raw).trim();
    if (trimmed === '' || isNaN(parseInt(trimmed, 10))) {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) { render(cart); });
      return;
    }
    var qty = Math.max(0, parseInt(trimmed, 10));
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { render(cart); })
    .catch(function() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) { render(cart); });
    });
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { render(cart); });
  }

  function jcDrawerI18n(key, fallback) {
    return (window.JackeryConfig && window.JackeryConfig.i18n && window.JackeryConfig.i18n[key]) || fallback;
  }

  function formatMoney(cents) {
    // market-aware (JackeryConfig.money injected dle localization.country): EUR na SK, CZK na CZ.
    // CZK oddělovač tisíců TEČKA — sjednoceno s money-market snippetem / kolekcí / product.js (DF-03).
    var jc = (window.JackeryConfig && window.JackeryConfig.money) || {};
    if (jc.currency === 'EUR') {
      return (cents / 100).toLocaleString(jc.locale || 'sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    var amount = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return amount + ' Kč';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

})();
